const balloonLayout = `
  <div class="place__balloon-content" data-event-id="{{ properties.markerId }}">
    {% if (properties.title) %}
      {% if (properties.image && properties.image.little_thumb_http_path) %}
        <div class="place__balloon-image" style="background-image:url({{ properties.image.little_thumb_http_path }})"></div>
      {% endif %}
      <div class="place__balloon-title">{{ properties.title|default:"" }}</div>
      <div class="place__balloon-address">{{ properties.location|default:"" }}</div>
      {% if (properties.to) %}
        <div class="l-place__balloon-button">
          <a href="{{ properties.to }}" class="place__balloon-button" target="_blank">
            <span class='text'>Подробнее</span>
          </a>
        </div>
      {% endif %}
    {% else %}
      Загрузка...
    {% endif %}
  </div>
`;

function updateCluster(data, balloon, updateEvents, router, routeName) {
  let geoObjects = data.features;
  if (!geoObjects.every(go => go.properties.__UPDATED__)) {
    const ids = geoObjects.map(go => go.properties.markerId);
    updateEvents(ids)
      .then(res => {
        geoObjects = geoObjects.map(go => {
          const currentRes = res.filter(item => +item.id === +go.properties.markerId)[0]
          if (!currentRes) return go;
          const { id, name, image, location, url_code, href, __UPDATED__ } = currentRes;
          const to = href || (id && router.resolve({
            name: routeName,
            params: { id, code: url_code || '' }
          }).href);
          go.properties = Object.assign(go.properties, { title: name, image, location, to, __UPDATED__ });
          return go;
        });
        data.features = geoObjects;
        balloon.setData(data);
      })
  };
}

function updateMarker(data, balloon, updateEvents, router, routeName) {
  const id = data.properties.markerId;
  updateEvents([id])
    .then(res => {
      const { id, name, image, location, url_code, href, __UPDATED__ } = res[0];
      const to = href || (id && router.resolve({
        name: routeName,
        params: { id, code: url_code || '' }
      }).href);
      data.properties = Object.assign(data.properties, { title: name, image, location, to, __UPDATED__ });
      balloon.setData(data);
    })
}

export { balloonLayout, updateCluster, updateMarker }



// WEBPACK FOOTER //
// ./src/components/page/map/mapUtils.js